/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gate_Highlight_Team_StarterInputs */



/**
* | output |
* | --- |
* | "Everything in Starter" |
*
* @param {Plan_Gate_Highlight_Team_StarterInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_highlight_team_starter = /** @type {((inputs?: Plan_Gate_Highlight_Team_StarterInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Highlight_Team_StarterInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alles aus Starter")
	return /** @type {LocalizedString} */ ("Everything in Starter")
});